import { BooleanInput } from '@angular/cdk/coercion';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { FormControl, FormGroup, FormRecord } from '@angular/forms';
import { SearchState } from '../../store/search.state';
import { AvailableFilterOptionDto } from '../../types/available-filter-option-dto.type';
import { SearchFilterValueDto } from '../../types/search-filter-value-dto.type';
import { SearchFilterCheckbox } from '../search-filter-checkbox/search-filter-checkbox.component';
import { SearchFilterRange } from '../search-filter-range/search-filter-range.component';
import { SearchFilterSelect } from '../search-filter-select/search-filter-select.component';

@Component({
  selector: 'procure-search-filter',
  templateUrl: './search-filter.component.html',
  imports: [SearchFilterCheckbox, SearchFilterRange, SearchFilterSelect],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchFilter {
  readonly filter = input.required<AvailableFilterOptionDto>();

  readonly isGlobal = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  protected readonly control = computed(() =>
    this.isGlobal() ? this.globalControl() : this.entityControl(),
  );

  protected readonly entityControl = computed(() => {
    const activeTab = this.state.activeTab();

    if (!activeTab?.entityType) {
      return null;
    }

    return this.state.entityFilterForms.controls[activeTab.entityType].controls[
      this.filter().fieldName
    ] as unknown as FormControl<SearchFilterValueDto[] | null>;
  });

  protected readonly globalControl = computed(
    () => this.state.globalFilterForm.controls[this.filter().fieldName],
  );

  private readonly state = inject(SearchState);

  protected isFormRecord(control: unknown): control is FormRecord<FormControl> {
    return control instanceof FormRecord;
  }

  protected isFormGroup(control: unknown): control is FormGroup {
    return control instanceof FormGroup;
  }

  protected isFormControl(control: unknown): control is FormControl {
    return control instanceof FormControl;
  }
}
